import { render, staticRenderFns } from "./ExpensesActions.vue?vue&type=template&id=4db2d8cb&scoped=true&"
import script from "./ExpensesActions.vue?vue&type=script&lang=js&"
export * from "./ExpensesActions.vue?vue&type=script&lang=js&"
import style0 from "./ExpensesActions.vue?vue&type=style&index=0&id=4db2d8cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db2d8cb",
  null
  
)

export default component.exports